import React from 'react'
import {Link} from 'react-router-dom'
import '../CSS/style.css'
import '../CSS/responsive.css'
import facebook  from "../assets/icons_social/facebook.png"
import instagram  from "../assets/icons_social/instagram.png"
import linkedin  from "../assets/icons_social/linkedin.png"
import twitter  from "../assets/icons_social/twitter.png"
import youtube  from "../assets/icons_social/youtube.png"
import cprog from "../assets/icons_programming/c_programming.png"
import cppprog from "../assets/icons_programming/c++_programming.png"
import javaprog from "../assets/icons_programming/java_programming.png"
import pythonprog from "../assets/icons_programming/python_programming.png"

export default function Footer() {
  return (
    <div id='footer'>    
    
    <div   className='flex'>
        <div className="sociallinks">
            <span className="sec-heading">Social Links : </span>
            <ul className="links">
                <li><span className="socials"><img className='socialicons' src={facebook} alt="Facebook" /><Link target='_blank' to="https://facebook.com/rudra.sahil.58">Facebook</Link></span></li>
                <li><span className="socials"><img className='socialicons' src={instagram} alt="Instagram" /><Link target='_blank' to="https://instagram.com/_krsahil">Instagram</Link></span></li>
                <li><span className="socials"><img className='socialicons' src={linkedin} alt="LinkedIn" /><Link target='_blank' to="https://linkedin.com/in/krsahil">LinkedIn</Link></span></li>
                <li><span className="socials"><img className='socialicons' src={twitter} alt="Twitter" /><Link target='_blank' to="https://twitter.com/_krsahil">Twitter</Link></span></li>
                <li><span className="socials"><img className='socialicons' src={youtube} alt="YouTube" /><Link target='_blank' to="https://youtube.com/@programmersahil">YouTube</Link></span></li>
            </ul>
        </div>

        <div className="quicklinks">
            <span className="sec-heading">Quick Links : </span>
            <ul className="links">
                <li><span className='socials'><img className='socialicons' src={cprog} alt="C Program" /><Link to="/cprograms" className='cursor-pointer'>C Programs</Link></span></li>
                <li><span className='socials'><img className='socialicons' src={cppprog} alt="C++ Program" /><Link to="/c++programs" className='cursor-pointer'>C++ Programs</Link></span></li>
                <li><span className='socials'><img className='socialicons' src={javaprog} alt="Java Program" /><Link to="/java_programs" className='cursor-pointer'>Java Programs</Link></span></li>
                <li><span className='socials'><img className='socialicons' src={pythonprog} alt="Python Program" /><Link to="/python_programs" className='cursor-pointer'>Python Programs</Link></span></li>
            </ul>           
        </div>
    </div>
    <hr />
    <div className="text-center">&copy;All rights Reserved | www.Unlockcode.tech | 2023</div>
    </div>

  )
}
